import { createSlice } from "@reduxjs/toolkit";

const licensesSlice = createSlice({
  name: "licenses",
  initialState: { list: [], selectedLicense: undefined },
  reducers: {
    set(state, action) {
      state.list = action.payload;
    },
    setSelectedLicense(state, action) {
      state.selectedLicense = state.list.find((l) => l.id === action.payload);
    },
    resetSelected(state) {
      state.selectedLicense = undefined;
    },
    addLicense(state, action) {
      state.list.push(action.payload);
    },
    updateLicense(state, action) {
      const index = state.list.findIndex((l) => l.id === action.payload.id);
      state.list[index] = {...state.list[index], ...action.payload};
    },
    delLicense(state, action) {
      state.list = state.list.filter((l) => l.id !== action.payload);
      state.selectedLicense = null;
    },
    bindLicense(state, action) {
      const licenseId = action.payload.licenseId;
      const bindResult = action.payload.bindResult;

      const license = state.list.find((l) => l.id === licenseId);
      state.selectedLicense.publicKey = license.publicKey =
        bindResult.publicKey;
      state.selectedLicense.licenseText = license.licenseText =
        bindResult.licenseText;
      state.selectedLicense.state = license.state = "Assigned";
      state.selectedLicense.hardwareId = license.hardwareId =
        bindResult.hardware.identifier;
    },
    unbindLicense(state, action) {
      const license = state.list.find((l) => l.hardwareId === action.payload);
      if (license !== undefined) {
        state.selectedLicense.hardwareId = license.hardwareId = "";
        state.selectedLicense.state = license.state = "Free";
        state.selectedLicense.publicKey = license.publicKey = "";
        state.selectedLicense.licenseText = license.licenseText = "";
      }      
    },
    blockLicense(state, action) {
      const license = state.list.find((l) => l.id === action.payload);
      state.selectedLicense.state = license.state = "Canceled";
    },
  },
});

export const licensesActions = licensesSlice.actions;

export default licensesSlice.reducer;
